/* global $ */

export default {
  name: "SidebarContext",

  props: {
    main_label: {
      type: String,
      required: true
    },
    sub_label: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      required: true
    },
    active_id: {
      type: [String, Number],
      default: null
    },
    open: {
      type: Boolean,
      default: false
    }
  },

  emits: ["toggle", "select"],

  mounted() {
    this.bindOutsideClick();
  },

  beforeUnmount() {
    $(document).off("click.sidebar-context");
  },

  methods: {
    isLive(item) {
      return item.id?.includes("(Live)");
    },
    formatLabel(item) {
      const label = item.label || item.title || "";

      // If already contains (Live), return as-is
      if (label.includes("(Live)")) return label;

      // If NOT live, return normal
      if (!this.isLive(item)) return label;

      // Otherwise append (Live)
      return `${label} (Live)`;
    },

    toggle() {
      this.$emit("toggle");
    },

    select(item) {
      this.$emit("select", item);
    },

    isActive(item) {
      return item.id === this.active_id;
    },

    bindOutsideClick() {
      $(document).on("click.sidebar-context", (e) => {
        const dropdown = this.$el.querySelector(".sidebar-context-dropdown");
        const toggle = this.$el.querySelector(".context-card");

        // If the dropdown isn't open, do nothing
        if (!this.open) return;

        if (!dropdown?.contains(e.target) && !toggle?.contains(e.target)) {
          this.$emit("toggle");
        }
      });
    }
  }
};
